import { AlertModal, Box, Flex, Image, Text, TextLink } from '@modusign/design-system';

import chromeIcon from '@app/assets/browser-chrome-icon.png';
import edgeIcon from '@app/assets/browser-edge-icon.png';

interface BlockIEModalProps {
  title: string;
  isOpen: boolean;
  onConfirm: () => void;
}

export default function BlockIEModal({ title, isOpen, onConfirm }: BlockIEModalProps) {
  return (
    <AlertModal isOpen={isOpen} maxWidth="xs" title={title} variant="warning" onClose={onConfirm}>
      <Text>
        지원되지 않는 브라우저(IE)로 접속하셨어요.
        <br />
        Chrome이나 Edge 브라우저를 이용해 주세요.
      </Text>
      <Flex
        bg="boxBackgroundNeutralBase"
        border="1px solid"
        borderColor="boxBorderNeutralBase"
        gap={7}
        justifyContent="center"
        mt={6}
        p={7}
        width="100%"
      >
        <TextLink href="https://www.google.com/chrome/" target="_blank">
          <Image alt="" display="block" src={chromeIcon} sx={{ mx: 'auto', mb: 3 }} />
          Google Chrome
        </TextLink>
        <Box bg="dividerNeutralSlightlyLight" height="71px" />
        <TextLink href="https://www.microsoft.com/edge/" target="_blank">
          <Image alt="" display="block" src={edgeIcon} sx={{ mx: 'auto', mb: 3 }} />
          Microsoft Edge
        </TextLink>
      </Flex>
    </AlertModal>
  );
}
